export interface YotpoPreview {
	averageScore: number;
	totalReviews: number;
}

let previewPromise: Promise<YotpoPreview> | null = null;
let yotpoPreview: YotpoPreview;

async function getYotpoValues(): Promise<YotpoPreview> {
	const response = await fetch('/api/yotpo/preview');

	if (response.status !== 200) {
		return {
			averageScore: 0,
			totalReviews: 0
		};
	}

	const res = await response.json();

	return {
		averageScore: res.bottomline.average_score,
		totalReviews: res.bottomline.total_reviews
	};
}

export async function getYotpoPreview(): Promise<YotpoPreview> {
	if (previewPromise) {
		return previewPromise;
	}

	if (!yotpoPreview) {
		previewPromise = getYotpoValues();

		try {
			yotpoPreview = await previewPromise;
		} finally {
			previewPromise = null;
		}
	}

	return yotpoPreview;
}
